
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectLangObj } from '../../reducers/langReducer.js';
import SliderElement from '../slider/SliderElement.js';
import DocumentSlider from '../slider/DocumentSlider.js';
import { selectRazno } from '../../reducers/raznoReducer.js';
import { fetchRazno } from '../../fetch/documents.js';
import SliderItem from '../../models/SliderItem.js';


// var links = [

//   {
//     url:"https://www.youtube.com",
//     title:"YouTube",
//     image:"https://upload.wikimedia.org/wikipedia/commons/thumb/0/09/YouTube_full-color_icon_%282017%29.svg/512px-YouTube_full-color_icon_%282017%29.svg.png"
    
//   },  
//   {
//     url:"https://backapalankavesti.com/",
//     title:"BAP Dešavanja",
//     image:"https://backapalankavesti.com/wp-content/uploads/2018/08/logo_50.png"
    
//   },  


// ]

function MainLinks(props) {
  const razno = useSelector(selectRazno);
  const dispatch = useDispatch();
  const langObj = useSelector(selectLangObj);
   const appendItems = () => {
     dispatch(fetchRazno());
   }
   
   useEffect(() => {

    appendItems();
  }, []);

  function getItems(g){


    return g.map(e => { return new SliderItem( e.рбр, e.наслов, e.линкП,e.линк,e.датум, e.прикупио); }).map(e => {

      return (
        <SliderElement auto={false} key={e.url} data={e}></SliderElement>
      )
    })
  }
  return (
     /* {
            "рбр": 24,
            "тип": "Фото",
            "име": "АЦ0001",
            "наслов": "фотографија",
            "датум": "2024-10-29",
            "прикупио": "С. Тришић",
            "период": 0,
            "линк": "https://i.ibb.co/sRBNGHV/img002.jpg",
            "линкП": "https://ibb.co/9gM1Ltr"
        }, */
           <DocumentSlider dynamic={false} title={langObj["Links"]} getItems={()=>getItems(razno)}></DocumentSlider>
  );
}

export default MainLinks;
